var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoCollection(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 204,
    height: 204,
    viewBox: "0 0 204 204",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_17",
    x: 0,
    y: 0,
    width: 204,
    height: 204,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.051
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "no-tours-icon",
    transform: "translate(30 30)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -30, -30)",
    filter: "url(#Path_17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17-2",
    "data-name": "Path 17",
    d: "M306,323.88a72,72,0,1,1-72,72A72,72,0,0,1,306,323.88Z",
    transform: "translate(-204 -293.88)",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M302.437,346.47A31.027,31.027,0,0,0,271.41,377.5c0,23.268,31.027,57.623,31.027,57.623s31.027-34.355,31.027-57.623A31.027,31.027,0,0,0,302.437,346.47Zm0,42.1A11.078,11.078,0,1,1,313.515,377.5a11.078,11.078,0,0,1-11.078,11.078Z",
    transform: "translate(-230.437 -318.79)",
    fill: "#7d858c"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    transform: "translate(77.455 76.005)",
    fill: "#ff5351",
    stroke: "#fff",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.615,
    cy: 17.615,
    rx: 17.615,
    ry: 17.615,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 17.615,
    cy: 17.615,
    rx: 19.615,
    ry: 19.615,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M334.83,405.043l-1.615-1.623-6.373,6.4-6.389-6.4-1.623,1.623,6.4,6.389-6.4,6.4,1.623,1.623,6.389-6.4,6.4,6.4,1.615-1.623-6.436-6.4Z",
    transform: "translate(-231.827 -317.741)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoCollection);
export default __webpack_public_path__ + "static/media/no-collection.d0b525326d0c51d9a08b0fa506f82c1d.svg";
export { ForwardRef as ReactComponent };